import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/CharacterPlaceholder.png'


const _withScopeId = n => (_pushScopeId("data-v-96fd5662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "character__content" }
const _hoisted_2 = { class: "character__person" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "character__level" }
const _hoisted_5 = { class: "character__bars" }
const _hoisted_6 = { class: "character__info" }
const _hoisted_7 = { class: "character__core-bars" }
const _hoisted_8 = { class: "character__additional-bars" }
const _hoisted_9 = { class: "character__luck" }
const _hoisted_10 = { class: "character__luck-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManageMana = _resolveComponent("ManageMana")!
  const _component_ManageMentalState = _resolveComponent("ManageMentalState")!
  const _component_ManageHealth = _resolveComponent("ManageHealth")!
  const _component_EditCharacterInfo = _resolveComponent("EditCharacterInfo")!
  const _component_HealthBar = _resolveComponent("HealthBar")!
  const _component_MentalStateBar = _resolveComponent("MentalStateBar")!
  const _component_ManaBar = _resolveComponent("ManaBar")!
  const _component_IntoxicationBar = _resolveComponent("IntoxicationBar")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: _ctx.$t('character'),
    class: "character"
  }, {
    buttons: _withCtx(() => [
      _createVNode(_component_ManageMana),
      _createVNode(_component_ManageMentalState),
      _createVNode(_component_ManageHealth),
      _createVNode(_component_EditCharacterInfo)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "character__image",
            src: _imports_0,
            alt: _ctx.$t('character-image')
          }, null, 8, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.characters[_ctx.current].level), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.characters[_ctx.current].name || _ctx.$t("new-character")), 1),
            _createElementVNode("h3", null, _toDisplayString(_ctx.characters[_ctx.current].race ||
								_ctx.$t(
									"click-edit-button-above-to-change-race-and-name"
								)), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_HealthBar),
            _createVNode(_component_MentalStateBar)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ManaBar, {
              mana: _ctx.characters[_ctx.current].mana
            }, null, 8, ["mana"]),
            false
              ? (_openBlock(), _createBlock(_component_IntoxicationBar, {
                  key: 0,
                  intoxication: _ctx.characters[_ctx.current].intoxication
                }, null, 8, ["intoxication"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.characters[_ctx.current].luck), 1),
          _createVNode(_component_Icon, {
            name: "Luck",
            class: "character__luck-icon"
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}